(ns frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.team-letter
  (:require
   [common.util :as cu]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]))

(defn image
  [data]
  (when-not (cu/blank-value? (:image data))
    (card/card
     ""
     {:image (str (:image data))
      :width 250}
     (text-content/optional-footer data))))

(defn team-letter-page-english
  [data]
  (let [{:keys [team-letter team-letter-2]} data]
    (page/page
     (page/page-title-with-line {:page-title "Team letter" :toc-item true :reporting-period (:reporting-period data)})
     (column/columns
      (card/card
       ""
       (text-content/rich-content (->> team-letter
                                       :letter-text
                                       :rich-content)))
      (card/card
       ""
       (text-content/rich-content (->> team-letter
                                       :letter-text-2
                                       :rich-content)))
      (image (:letter-image team-letter))))))

(defn team-letter-page-finnish
  [data]
  (let [{:keys [team-letter team-letter-2]} data]
    (when-not (and (cu/blank-value? (->> team-letter
                                         :letter-text-finnish
                                         :rich-content))
                   (cu/blank-value? (->> team-letter
                                         :letter-text-2-finnish
                                         :rich-content)))
      (page/page
       (page/page-title-with-line {:page-title "Team letter (in Finnish)"
                                   :toc-item true
                                   :reporting-period (:reporting-period data)})
       (column/columns
        (card/card
         ""
         (text-content/rich-content (->> team-letter
                                         :letter-text-finnish
                                         :rich-content)))
        (card/card
         ""
         (text-content/rich-content (->> team-letter
                                         :letter-text-2-finnish
                                         :rich-content)))
        (image (:letter-image team-letter)))))))

(defn team-letter-pages
  [data]
  (let []
    (when-not (cu/blank-value? (:reference-date data))
      [(team-letter-page-english data)
       (team-letter-page-finnish data)])))

